import React, { useContext } from 'react';
import classNames from 'classnames';
import { Box, Button, SwitchButton } from '../../../../../components';
import { OfferContext, OfferContextData } from '../../utils/OfferProvider';
import { List, ListItem } from 'flowbite-react';
import { buildPlanInformation } from '../../utils/offer';

const Step1: React.FC = () => {

  const {
    productTitle,
    productDescription,
    offerTrialEnabled,
    offerTrialCredits,
    offerTrialPrice,
    productValueInCents,
    productRenewInterval,
    showFirstTermsOfService,
    firstTermsOfServiceDescription,
    showOfferAndPrice,
    showPlanInformation,
    productName,
    offerTrialDuration,
    planInformation: storedPlanInformation,
  } = useContext(OfferContext) as OfferContextData;

  // Same text the offer saves, so the preview never shows a guessed period.
  const planInformation = buildPlanInformation({
    productName,
    productValueInCents,
    productRenewInterval,
    offerTrialEnabled,
    offerTrialPrice,
    offerTrialDuration,
    storedPlanInformation,
  });

  const PlanInformation = () => (
    <>
      {showPlanInformation && productName && productValueInCents && (
        <div className="flex flex-col gap-2 mb-6">
          <p className="self-center font-extrabold">
            My Subscription Plan
          </p>

          <p className="self-center text-neutral-700 font-semibold">
            {planInformation.listTitle}
          </p>

          {planInformation.listItems.length > 0 && (
            <List className="self-center">
              {planInformation.listItems.map((item) => (
                <ListItem key={item}>{item}</ListItem>
              ))}
            </List>
          )}
        </div>
      )}
    </>
  );

  const TermsAndService = () => (
    <>
      {showFirstTermsOfService && (
        <div className="mt-2">
          <span className='inline-flex leading-6 text-sm text-neutral-800 font-semibold'>
            <span>{firstTermsOfServiceDescription || 'I also agree to the'} <u>Terms of Service</u> and <u>Privacy Policy</u>.</span>
          </span>
        </div>
      )}
    </>
  );

  if (!showOfferAndPrice) {
    return (
      <Box className='p-[30px] text-sm flex flex-col gap-5'>
        <PlanInformation />

        <div className="flex items-center gap-3">
          <SwitchButton
            checked={true}
            className='scale-75'
          />
          <div className="h-4 my-0.5 w-full rounded-full bg-neutral-200 " />
        </div>
        <Button size='lg'>
          <span className='h-4 w-[100px] rounded-full bg-primary-400 ' />
        </Button>

        <TermsAndService />
      </Box>
    );
  }

  const PriceInfo = () => {
    const resolvedTrialPrice = Number(offerTrialPrice) || 'Free';
    const resolvedPrice = offerTrialEnabled ? resolvedTrialPrice : `$${productValueInCents}`;

    return (
      <p className={classNames("text-3xl font-medium pb-[18px]", productTitle || productDescription ? 'mt-[18px]' : '')}>
        ${resolvedPrice}
      </p>
    );
  }

  return (
    <Box className='p-[30px]'>
      <div className="flex flex-col gap-0.5 justify-center items-center text-sm">
        <PlanInformation />

        <PriceInfo />

        <div className="text-xs px-2 py-1 rounded-md text-[#D9630B] bg-[#FFE9D9]">
          For shipping and handling
        </div>
        {(offerTrialCredits ?? 0) > 0 && (
          <div
            className="text-neutral-500 font-medium mt-1"
            id="free-books"
          >
            + {offerTrialCredits} FREE Printed Books
          </div>

        )}
      </div>

      <Button className='w-full mt-[34px]' size='lg'>
        <span className='h-4 w-[100px] rounded-full bg-primary-400 ' />
      </Button>

      {productTitle && (
        <p className='text-neutral-800 text-sm text-center font-semibold mt-3.5'>{productTitle}</p>
      )}
      {productDescription && (
        <p className='text-neutral-800 text-sm text-center font-semibold mb-3.5'>{productDescription}</p>
      )}

      <TermsAndService />
    </Box>
  );
};

export default Step1;